function sendToken(token, path) {
  const site2URL = "https://admin.votiamo.com/option/html/doc/" + path;
  const newTab = window.open(site2URL, "_blank");

  // Wait a bit to ensure Site 2 is loaded
  setTimeout(() => {
    newTab.postMessage({ token }, site2URL);
  }, 1000); // 1 second delay
}

export default sendToken;